import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import axios from 'axios'
import qs from 'qs'
import * as filters from './assets/js/filters.js'

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;

Vue.config.productionTip = false

Object.keys(filters).forEach(k => Vue.filter(k, filters[k])) //注册过滤器

const newVue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

export default newVue;